export default {
  "content": "<path d=\"M11 21H3v-2h8v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 15a1 1 0 011 1v4a1 1 0 01-1 1h-6a1.001 1.001 0 01-1-1v-4a1 1 0 011-1h6zm-5 4h4v-2h-4v2z\" fill=\"#7B61FF\"/><path d=\"M11 17H3v-2h8v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 3a1 1 0 011 1v8a1 1 0 01-1 1H4a1.001 1.001 0 01-1-1V4a1 1 0 011-1h6zm-5 8h4V5H5v6z\" fill=\"#7B61FF\"/><path d=\"M21 13h-8v-2h8v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 3a1 1 0 011 1v4a1 1 0 01-1 1h-6a1.001 1.001 0 01-1-1V4a1 1 0 011-1h6zm-5 4h4V5h-4v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};